var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAccFieldUpdate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_acc-field-update",
    transform: "translate(-318 -184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 16,
    height: 16,
    transform: "translate(318 184)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M7.665,6.83H.636a.621.621,0,0,1-.449-.183A.6.6,0,0,1,0,6.2V.622A.6.6,0,0,1,.184.183.611.611,0,0,1,.63,0H12.2a.6.6,0,0,1,.442.184.6.6,0,0,1,.184.442V1.665h-1V1H1V5.831H7.665ZM1,5.831v0Zm10.832,1H9.583a.489.489,0,0,1-.355-.146.476.476,0,0,1-.147-.349.489.489,0,0,1,.147-.354.482.482,0,0,1,.355-.15h2.248V3.578a.483.483,0,0,1,.146-.35.476.476,0,0,1,.349-.147.489.489,0,0,1,.354.147.475.475,0,0,1,.15.35V5.831h2.253a.485.485,0,0,1,.35.146.475.475,0,0,1,.147.347.492.492,0,0,1-.147.356.477.477,0,0,1-.35.15H12.83V9.078a.489.489,0,0,1-.146.355.475.475,0,0,1-.347.147.492.492,0,0,1-.356-.147.482.482,0,0,1-.15-.355V6.83",
    transform: "translate(318.21 187.21)",
    fill: "#00a358"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccFieldUpdate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/accFieldUpdate.9f749d53.svg";
export { ForwardRef as ReactComponent };